























import {Component, Watch, Prop, Mixins} from 'vue-property-decorator'
import ModalBaseBody from './ModalBaseBody.vue'
import ServiceSelect from '@/components/ServiceSelect.vue'
import {
  IServiceType,
  IServiceTypePrice,
  IServiceTypePriceReverse,
  ServiceChoice,
  ServiceTypePriceReverse
} from '@/entities'
import onLocaleChangeMixin from '@/mixins/onLocaleChangeMixin'
import modalStepMixin from '@/mixins/modalStepMixin'
import {updateItems} from '@/lib'
import {IOption} from '@/components/lib/models'

@Component({
  components: {
    ModalBaseBody,
    ServiceSelect
  }
})
export default class ModalConfigBody extends Mixins(onLocaleChangeMixin, modalStepMixin) {

  @Prop({ default: 'default' }) readonly type?: ServiceChoice | 'default';

  private showError: boolean = false;

  protected getHandlers(): { [key: string]: Function } {
    let self = this;
    return {
      next: (function () {
        return new Promise<void>((resolve, reject) => {
          if (self.error) {
            self.showError = true;
            reject();
          } else {
            self.showError = false;
            resolve();
          }
        });
      })
    }
  }

  get error(): string {
    return this.currentService?.price ? '' : (this.$t(`form.errors.select-${ this.type }`) as string);
  }

  get errorToShow(): string {
    return this.showError ? this.error : '';
  }

  protected initFetches = [
    this.getServices
  ];

  protected reFetches = [
    this.updateServices
  ];

  get currentService(): IServiceTypePriceReverse | null {
    return this.subject;
  }
  set currentService(value: IServiceTypePriceReverse | null) {
    this.$emit('update:subject', {
      ...this.subject,
      ...value
    });
  }

  private services: IServiceTypePriceReverse[] = [];

  get servicesToShow(): IServiceTypePriceReverse[] {
    return this.services.filter((service: IServiceTypePriceReverse) => service.validate());
  }

  get servicesOptions(): IOption<IServiceTypePriceReverse>[] {
    return this.servicesToShow.map((service: IServiceTypePriceReverse) => ({
      name: '',
      value: service
    }));
  }

  private getServices(): void {
    (new Promise<IServiceTypePriceReverse[]>((resolve, reject) => {
      const service_type: IServiceType = this.subject?.service_type;
      const prices: IServiceTypePrice[] = service_type?.prices;

      if (prices?.length) {
        resolve(prices.map(price => new ServiceTypePriceReverse({
          ...price,
          service_type
        })));
      } else {
        this.fetchServices()
            .then(resolve)
            .catch(reject);
      }
    }))
        .then(res => {
          if (res.length === 1) {
            this.$emit('one-subject', res[0]);
          }
          this.services = res;
        })
        .catch(() => {})
        .finally(() => {
          this.data.loading = false;
        });
  }

  private fetchServices(): Promise<IServiceTypePriceReverse[]> {
    this.data.loading = true;
    let type = this.type;
    type = (type === 'default') ? undefined : type;
    return this.$storage.actions.fetchServiceTypePrices(type ? {
      type
    } : undefined);
  }

  private updateServices(): void {
    updateItems(this.services, this.$storage.actions.getServiceTypePriceById);
  }

  @Watch('error')
  onErrorChanged() {
    this.$emit('update:error', this.error);
  }

  deactivated() {
    this.showError = false;
    this.data.loading = false;
  }

}
